import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import * as projectActions from "../../../../actions/project.actions";
import * as commonActions from "../../../../actions/common.actions";
import * as dropdownsActions from "../../../../actions/dropdowns.actions";
import * as citiesActions from "../../../../actions/cities.actions";

import Toast from "../../../../components/common/toast/Toast";
import ProjectSOWView from "../components/ProjectSOWView";
import ProjectSOWEdit from "../components/ProjectSOWEdit";

import CompleteProjectModal from "../../../common/completeProjectModal/CompleteProjectModal";
import declineModal from "../../memberProfile/components/declineModal";
import hireModal from "../../memberProfile/components/hireModal";
import acceptModal from "../components/acceptModal";
import requestEditModal from "../components/requestEditModal";

import styles from "./MemberProposalContainer.scss";
import noMessagesIcon from "../../../../assets/images/empty-project.svg";

const subHeader = (pitchId, memberId, projectId) => {
  return {
    items: [
      {
        caption: "Member Profile",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/memberProfile`
      },
      {
        caption: "Statement of Work",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/sow`
      },
      {
        caption: "Messages",
        url: `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/messages`
      }
    ],
    activeItem: 1
  };
};

const pitchPending = (hireMember, declineMember, urlMessages) => ({
  color: "blue",
  title: "This Member Has Pitched Your Project",
  text: (
    <span>
      Click <Link to={urlMessages}>Messages</Link> to communicate with this
      member directly. Click Hire to decline all other member pitches and move
      this member to the Statement of Work phase.
    </span>
  ),
  buttons: [
    {
      text: "Decline",
      type: "modalTrigger",
      modal: declineModal,
      modalClick: declineMember
    },
    {
      text: "Hire",
      type: "modalTrigger",
      color: "blue",
      modal: hireModal,
      modalClick: hireMember
    }
  ]
});

const pitchDeclined = () => ({
  center: false,
  color: "grey",
  title: "The Pitch is Declined",
  text: "You declined this pitch"
});

const awaitingSow = memberName => ({
  color: "blue",
  title: `You have selected ${memberName}`,
  text: `We have alerted her to submit her SOW for this project.
    When she completes it, we will notify you by email.`
});

// const sowEdisRequestedHeaderBar = () => ({
//   center: true,
//   color: 'grey',
//   title: 'The Member has been notified that you requested modifications. '
// });

const sowApprovedHeaderBar = (completeProject, projectId) => ({
  center: false,
  color: "grey",
  title: "Your Project is Underway",
  text: `After you’ve completed the project,
   click the button on the right to kick off the invoicing and review process.`,
  buttons: [
    {
      text: "Complete Project",
      type: "modalTrigger",
      modalProps: {
        completeProject,
        projectId
      },
      modal: CompleteProjectModal
    }
  ]
});

const projectCompletedHeaderBar = completeProject => ({
  center: false,
  color: "grey",
  title: "The project has been completed.",
  buttons: [
    {
      text: "Submit Feedback",
      onClick: completeProject
    }
  ]
});

const sowPendingApprovalHeaderBar = (acceptSow, requestEdit) => ({
  color: "blue",
  title: "SOW in Draft",
  text: `The Member has submitted the SOW below. If it’s ready, hit “Accept”.
  Otherwise, hit “Request Edits” to message her about changes.`,
  buttons: [
    {
      type: "modalTrigger",
      color: "blue",
      text: "Request Edits",
      modal: requestEditModal,
      modalClick: requestEdit
    },
    {
      text: "Accept",
      type: "modalTrigger",
      modal: acceptModal,
      modalClick: acceptSow
    }
  ]
});

class MemberProposalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentEmployerProjectState: null,
      sow: null,
      member: null
    };

    this.acceptSow = this.acceptSow.bind(this);
    this.completeProject = this.completeProject.bind(this);
    this.declineMember = this.declineMember.bind(this);
    this.hireMember = this.hireMember.bind(this);
    this.requestEdit = this.requestEdit.bind(this);
    this.submitSOW = this.submitSOW.bind(this);
  }

  componentDidMount() {
    const { pitchId, memberId, projectId } = this.props.match.params;

    this.props.projectActions.getMember(memberId);
    this.props.projectActions.getPitch(pitchId);
    this.props.projectActions.getProject(projectId);
    this.props.dropdownsActions.getProjectBudgetRateTypes();
    this.props.dropdownsActions.getWorkTypes();
    this.props.dropdownsActions.getTaxStatus();

    this.props.commonActions.setSubHeader(
      subHeader(pitchId, memberId, projectId)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevProps, prevState);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
    this.props.commonActions.setHeaderBar({});
  }

  setHeaderBar(prevProps, prevState) {
    if (!_.isEmpty(this.props.pitch) && this.props.pitch !== prevProps.pitch) {
      const member = this.props.member;
      const pitch = this.props.pitch;
      const sow = _.get(pitch, "sow");

      const pitchAccepted = _.get(pitch, "accepted");
      const sowPendingApproval = pitchAccepted && sow;
      const sowApproved = _.get(sow, "accepted");

      let headerBar = {};
      let currentEmployerProjectState = null;

      if (sowApproved) {
        // SOW Approved
        currentEmployerProjectState = "sowApproved";

        if (this.props.project) {
          switch (this.props.project.status.name) {
            case "completed":
              headerBar = projectCompletedHeaderBar(this.completeProject);
              break;

            case "reviewed":
              break;

            default:
              headerBar = sowApprovedHeaderBar(this.completeProject);
              break;
          }
        } else {
          headerBar = sowApprovedHeaderBar(this.completeProject);
        }
      } else if (sowPendingApproval) {
        // Awaiting for employer to approved the SOW
        currentEmployerProjectState = "sowPendingApproval";
        headerBar = sowPendingApprovalHeaderBar(
          this.acceptSow,
          this.requestEdit
        );
      } else if (pitchAccepted) {
        // Awaiting for member to send the SOW
        currentEmployerProjectState = "pitchAccepted";
        headerBar = awaitingSow(_.get(member, "first_name"));
      } else if (pitchAccepted === false) {
        currentEmployerProjectState = "pitchDeclined";
        headerBar = pitchDeclined();
      } else if (pitchAccepted === null) {
        // Pitch Pending
        currentEmployerProjectState = "pitchPending";

        const pitchId = this.props.pitch.id;
        const memberId = this.props.member.id;
        const projectId = this.props.pitch.match.project.id;
        const urlMessages = `/company/pitch/${pitchId}/member/${memberId}/project/${projectId}/messages`;

        headerBar = pitchPending(
          this.hireMember,
          this.declineMember,
          urlMessages
        );
      }

      if (
        currentEmployerProjectState !== prevState.currentEmployerProjectState ||
        sow !== prevState.sow
      ) {
        this.props.commonActions.setHeaderBar(headerBar);
        this.setState({ currentEmployerProjectState, sow, member });
      }
    }
  }

  acceptSow() {
    const payload = {
      sow_id: this.state.sow.id,
      accepted: true
    };

    this.props.projectActions.acceptSow(payload, this.props.pitch.id);
  }

  completeProject() {
    this.props.projectActions.completeProjectByEmployer(
      this.props.project.id,
      this.props.member.id
    );
  }

  declineMember(message) {
    const payload = {
      pitch_id: this.props.pitch.id,
      message: message,
      accept: false
    };
    this.props.projectActions.acceptPitch(payload);
  }

  hireMember() {
    const payload = {
      pitch_id: this.props.pitch.id,
      accept: true
    };
    this.props.projectActions.acceptPitch(payload);
  }

  requestEdit(message) {
    const payload = {
      sow_id: this.state.sow.id,
      edits_requested: true,
      message
    };

    this.props.projectActions.acceptSow(payload, this.props.pitch.id);
  }

  submitSOW(data) {
    const sow = this.state.sow;

    data.city = _.get(data, "city[0].description");

    if (!data.project_flexible) {
      data.project_flexible = false;
    }

    if (sow) {
      let pathName = _.replace(
        this.props.history.location.pathname,
        "/edit",
        ""
      );

      this.props.projectActions.updateSOW(
        sow.id,
        data,
        this.props.project.id,
        this.props.pitch.id,
        pathName
      );

      this.toast.showToast();
    }
  }

  renderContent() {
    const pitch = this.props.pitch;
    const pitchAccepted = _.get(pitch, "sow");

    return pitchAccepted ? this.renderSow() : this.renderDisabledMessage();
  }

  renderDisabledMessage() {
    return (
      <div className={styles.messages}>
        <div className={styles.noMessages}>
          <img
            src={noMessagesIcon}
            alt="noMessagesIcon"
            className={styles.noMessagesIcon}
          />
          <div className={styles.noMessagesText}>
            You need to accept and select this Member
            <br />
            in order to receive her SOW.
          </div>
        </div>
      </div>
    );
  }

  renderSow() {
    const {
      project,
      projectBudgetRateTypes,
      workTypes,
      taxStatus,
      cities,
      citiesActions
    } = this.props;

    const { sow, member } = this.state;
    const { pathname } = this.props.location;

    const employer = _.get(project, "user");
    const status = _.get(project, "status.name");
    const disabled = status === "completed";

    let component = null;

    if (sow) {
      component = (
        <ProjectSOWView
          sowData={sow}
          member={member}
          employer={employer}
          rateTypes={projectBudgetRateTypes}
          pitchId={this.props.match.params.pitchId}
          memberId={this.props.match.params.memberId}
          projectId={this.props.match.params.projectId}
        />
      );

      if (pathname.includes("/edit")) {
        component = (
          <ProjectSOWEdit
            sow={sow}
            projectBudgetRateTypes={
              projectBudgetRateTypes
                ? projectBudgetRateTypes.filter(type => type.id != 78)
                : projectBudgetRateTypes
            }
            workTypes={workTypes}
            taxStatus={taxStatus}
            onSubmit={this.submitSOW}
            disabled={disabled}
            cities={cities}
            onSearchCities={citiesActions.searchCitiesAutocomplete}
          />
        );
      }
    }

    return (
      <React.Fragment>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Your SOW has been updated"
          content="The member has received an email alerting them to the changes."
        />
        {component}
      </React.Fragment>
    );
  }

  render() {
    return <div>{this.renderContent()}</div>;
  }
}

const mapStateToProps = state => {
  return {
    pitch: state.project.pitch,
    member: state.project.member,
    project: state.project.data.data,
    projectBudgetRateTypes: state.dropdowns.projectBudgetRateTypes.data,
    workTypes: state.dropdowns.workTypes.data,
    taxStatus: state.dropdowns.taxStatus.data,
    cities: state.cities.cities.predictions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
    citiesActions: bindActionCreators(citiesActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberProposalContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/memberProposal/containers/MemberProposalContainer.js